<template>
    <div class="svg-container" :style="`--width:${width || '64px'}; --height:${height || '64px'};`">
        <svg :style="`--fillColor:${fill || '#000'};`" version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
        <path class="st0" d="M13.2,38.5l25.3-25.3c1-1,1-2.7,0-3.8l0,0c-1-1-2.7-1-3.8,0L9.5,34.8c-1,1-1,2.7,0,3.8l0,0
            C10.5,39.6,12.2,39.6,13.2,38.5z"/>
        <path class="st0" d="M34.8,38.5L9.5,13.2c-1-1-1-2.7,0-3.8l0,0c1-1,2.7-1,3.8,0l25.3,25.3c1,1,1,2.7,0,3.8l0,0
            C37.5,39.6,35.8,39.6,34.8,38.5z"/>
        </svg>
    </div>
</template>
<script type="text/javascript">
	// import helper from './../helpers';

	export default {
		name: 'CloseButton',
		props: ['fill','width','height'],
		data() {
			return {}
		}
	}
</script>
<style scoped>
    .svg-container {
        width: var(--width);
        height: var(--height);
    }

    .st0 {
        fill:var(--fillColor);
    }
</style>